// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/worksheets.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { WorksheetsService } from "./worksheets_pb";

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.CreateWorksheetSpace
 */
export const createWorksheetSpace = WorksheetsService.method.createWorksheetSpace;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetSpaces
 */
export const listWorksheetSpaces = WorksheetsService.method.listWorksheetSpaces;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.GetWorksheetNode
 */
export const getWorksheetNode = WorksheetsService.method.getWorksheetNode;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetNodes
 */
export const listWorksheetNodes = WorksheetsService.method.listWorksheetNodes;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.CreateWorksheetNode
 */
export const createWorksheetNode = WorksheetsService.method.createWorksheetNode;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.RenameWorksheetNode
 */
export const renameWorksheetNode = WorksheetsService.method.renameWorksheetNode;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.MoveWorksheetNode
 */
export const moveWorksheetNode = WorksheetsService.method.moveWorksheetNode;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.ArchiveWorksheetNode
 */
export const archiveWorksheetNode = WorksheetsService.method.archiveWorksheetNode;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.RestoreWorksheetNode
 */
export const restoreWorksheetNode = WorksheetsService.method.restoreWorksheetNode;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.AutosaveWorksheet
 */
export const autosaveWorksheet = WorksheetsService.method.autosaveWorksheet;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.SaveWorksheet
 */
export const saveWorksheet = WorksheetsService.method.saveWorksheet;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.GetWorksheetCommit
 */
export const getWorksheetCommit = WorksheetsService.method.getWorksheetCommit;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetCommits
 */
export const listWorksheetCommits = WorksheetsService.method.listWorksheetCommits;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.RunOnlineWorksheetCommit
 */
export const runOnlineWorksheetCommit = WorksheetsService.method.runOnlineWorksheetCommit;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.RunOfflineWorksheetCommit
 */
export const runOfflineWorksheetCommit = WorksheetsService.method.runOfflineWorksheetCommit;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.RunSqlWorksheetCommit
 */
export const runSqlWorksheetCommit = WorksheetsService.method.runSqlWorksheetCommit;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.CancelWorksheetRun
 */
export const cancelWorksheetRun = WorksheetsService.method.cancelWorksheetRun;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.GetWorksheetRun
 */
export const getWorksheetRun = WorksheetsService.method.getWorksheetRun;

/**
 * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetRuns
 */
export const listWorksheetRuns = WorksheetsService.method.listWorksheetRuns;
